<template>
  <main class="query container-fluid mf_container pb_50">
    <div class="queryType">
      <!-- 搜尋模式 -->
      <label>
        <!-- <div class="position-relative d-flex"> -->
        <div class="radio radio-inline mr_10">
          <input
            type="radio"
            name="queryType"
            value="family"
            id="queryType_family"
            v-model="queryType"
          />
          <label for="queryType_family">搜尋CRM家戶</label>
        </div>
        <div class="radio radio-inline mr-0">
          <input
            type="radio"
            value="noId"
            name="queryType"
            id="queryType_noId"
            v-model="queryType"
          />
          <label for="queryType_noId">搜尋空白建議書試算</label>
        </div>
        <!-- </div> -->
      </label>
    </div>
    <component :is="showComponent" @toDetail="toDetailHandler()"></component>
  </main>
</template>

<script>
import QueryCRM from "@/desktop/views/mf/components/2.Query/2-2-1.QueryProposal/QueryCRM.vue";
import QueryNoId from "@/desktop/views/mf/components/2.Query/2-2-1.QueryProposal/QueryNoId.vue";
export default {
  components: { QueryCRM, QueryNoId },
  data() {
    return {
      queryType: "family",
    };
  },
  created() {
    //如果有緩存資料，則直接跳轉到對應頁面
    if (this.$store.getters.QueryDetailTarget.insured_id) {
      this.$store.commit("update_queryDetailTarget", {
        is_crm: "1",
        insured_id:
          this.$store.getters.QueryDetailTarget.insured_id ||
          this.$store.getters.MfEditing.insured.insured_id,
        prod_idx: "",
        familyid: this.$store.getters.QueryDetailTarget.familyid,
      });
      this.$router.replace("/mf/query/queryDetail");
    }
    if (this.$route.query.noId == "1") {
      this.queryType = "noId";
    }
  },
  computed: {
    showComponent() {
      return this.queryType == "family" ? QueryCRM : QueryNoId;
    },
  },
};
</script>

<style lang="scss" scoped>
.queryType {
  padding: 44px 0 34px;
  border-bottom: solid 1px #c2c4c7;
  .radio {
    min-width: 140px;
    font-size: 16px;
  }
}
</style>
